import { Reducer } from 'redux';
import { IChangeRequestsListState } from '@/interfaces/change-requests-list-state';
import { PO_DETAILS_ACTIONS } from '../../actions';
import { CREATE_CHANGE_REQUEST } from '../create-change-request/create-change-request-actions';
import { PO_CHANGE_REQUEST } from '../create-po-change-request/actions';
import {
  CHANGE_REQUESTS_LIST_ACTIONS,
  BUYER_CONFIRM_CHANGE_REQUEST,
  EDIT_CHANGE_REQUEST,
  SUPPLIER_CONFIRM_CHANGE_REQUEST,
  IUpdateChangeRequestPayload
} from './change-requests-actions';
import { getFormControlDate, getFormattedDate } from '@/app/common/util/get-formatted-date';
import { addDaysToDate } from '@/app/common/util/date-utils';
import { IChangeRequestDetail } from '@/interfaces/change-request-detail';

const intialState: IChangeRequestsListState = {
  bucketTypeId: -1,
  loading: false,
  changeRequests: [],
  error: '',
  currentPage: 0,
  totalCount: 0
};

export const poItemChangeRequestsReducer: Reducer<IChangeRequestsListState> = (state = intialState, action: Action<string, any>) => {
  let changeRequests;
  switch (action.type) {
    // Request
    case BUYER_CONFIRM_CHANGE_REQUEST.REQUEST:
    case SUPPLIER_CONFIRM_CHANGE_REQUEST.REQUEST:
    case CHANGE_REQUESTS_LIST_ACTIONS.REQUEST:
      return { ...state, bucketTypeId: action.payload.bucketTypeId, loading: true };

    case EDIT_CHANGE_REQUEST.REQUEST:
      const payload = action.payload as IUpdateChangeRequestPayload;
      changeRequests = [...state.changeRequests];
      const index = changeRequests.findIndex(item => (item.changeRequestId === payload.changeRequestId));
      const changeRequestDetail: IChangeRequestDetail = {
        ...changeRequests[index],
        supplierDate: getFormControlDate(payload.supplierDate),
        supplierDeliveryDate: getFormattedDate(addDaysToDate(payload.supplierDate, payload.dayDiff)),
        reasonTypeId: payload.reasonTypeId,
        reasonTypeDescription: payload.reasonTypeDescription,
        supplierQuantity: payload.supplierQuantity,
        supplierUnitPrice: payload.supplierUnitPrice
      };

      changeRequests[index] = changeRequestDetail;
      return { ...state, changeRequests };

    // Success
    case BUYER_CONFIRM_CHANGE_REQUEST.SUCCESS:
      changeRequests = state.changeRequests.map((cr) => {
        if (cr.changeRequestId === action.payload.changeRequestId) {
          cr.confirmedDate = action.payload.confirmedDate;
        }
        return cr;
      });
      return { ...state, changeRequests, loading: false };

    case CHANGE_REQUESTS_LIST_ACTIONS.SUCCESS:
      return { ...state, loading: false, changeRequests: [...state.changeRequests, ...action.payload.items], totalCount: action.payload.total, currentPage: action.payload.offset };

    // Failure
    case CHANGE_REQUESTS_LIST_ACTIONS.FAILURE:
      return { ...state, loading: false, error: 'Error getting change requests.' };

    case BUYER_CONFIRM_CHANGE_REQUEST.FAILURE:
    case SUPPLIER_CONFIRM_CHANGE_REQUEST.FAILURE:
      return { ...state, loading: false, error: 'Error confirming change request.' };

    case CHANGE_REQUESTS_LIST_ACTIONS.REMOVE_FROM_STATE:
      changeRequests = state.changeRequests.filter(cr => cr.changeRequestId !== action.payload.changeRequestId);
      return { ...state, changeRequests, loading: false };

    case CHANGE_REQUESTS_LIST_ACTIONS.REMOVE_UNREAD:
      changeRequests = state.changeRequests.map(removeUnreadMapper(action.payload.changeRequestId));
      return { ...state, changeRequests };

    // Other
    case PO_DETAILS_ACTIONS.CLEAR:
    case CREATE_CHANGE_REQUEST.SUCCESS:
    case PO_CHANGE_REQUEST.SUCCESS:
    case CHANGE_REQUESTS_LIST_ACTIONS.CLEAR:
      return { ...state, changeRequests: [] };

    default:
      return state;
  }
};

const removeUnreadMapper = (changeRequestId: number) => (cr: IChangeRequestDetail) => {
  if (cr.changeRequestId === changeRequestId) {
    return { ...cr, hasUnreadMessages: false };
  }
  return cr;
};
